document.addEventListener('DOMContentLoaded', function () {
    const mobileBreakpoint = window.matchMedia('(max-width: 749px)');
    const menuDrawer = document.querySelector('.menu-drawer');
    const navigationContainer = document.querySelector('.menu-drawer__navigation-container');
    const expandedContainer = document.querySelector('.expanded.menu-drawer__navigation-container');
    const topMenuItems = menuDrawer.querySelectorAll('.ms-drawer-top-menu div');
    const breadcrumbs = menuDrawer.querySelectorAll('.breadcrumb.ms-drawer-middle-primary');
    const middleMenuItems = menuDrawer.querySelectorAll('.ms-drawer-middle-primary--open');
    const mediaDrawer = expandedContainer.querySelector('.menu-drawer__media');

    const mediaByType = new Map();
    const mediaMenusByType = new Map();
    const middleMenusByType = new Map();
    const breadcrumbsByType = new Map();
    let menuRequest = 0;
    let drawerState = { hasMedia: false, hasMediaMenu: false };

    expandedContainer.querySelectorAll('.menu-drawer__media > [data-item-type]').forEach((media) => {
        const items = mediaByType.get(media.dataset.itemType) || [];
        items.push(media);
        mediaByType.set(media.dataset.itemType, items);
    });
    expandedContainer.querySelectorAll('.menu-drawer__media-menu[data-item-type]').forEach((menu) => {
        mediaMenusByType.set(menu.dataset.itemType, menu);
    });
    menuDrawer.querySelectorAll('.ms-drawer-middle-menu[data-item-type]').forEach((menu) => {
        middleMenusByType.set(menu.dataset.itemType, menu);
    });
    breadcrumbs.forEach((breadcrumb) => {
        const items = breadcrumbsByType.get(breadcrumb.dataset.itemType) || [];
        items.push(breadcrumb);
        breadcrumbsByType.set(breadcrumb.dataset.itemType, items);
    });

    // Animation helpers
    const fadeOut = (element, duration = 200) => {
        if (!element || !element.isConnected) return Promise.resolve();
        return element.animate(
            { opacity: [1, 0] },
            { duration, easing: 'ease-out', fill: 'forwards' }
        ).finished;
    };

    const fadeIn = (element, duration = 250, delay = 0) => {
        if (!element || !element.isConnected) return Promise.resolve();
        return element.animate(
            { opacity: [0, 1] },
            { duration, easing: 'ease-in', fill: 'forwards', delay }
        ).finished;
    };

    const fadeOutAll = async (elements, duration = 150) => {
        if (!elements || elements.length === 0) return;
        await Promise.all([...elements].map(el => fadeOut(el, duration)));
        elements.forEach(el => {
            el.classList.remove('is-active');
        });
    };

    const fadeInAll = async (elements, duration = 200, stagger = 50) => {
        if (!elements || elements.length === 0) return;

        // Show first (hidden), then fade in
        elements.forEach((el, index) => {
            el.classList.add('is-active');
            // Stagger the fade-in for multiple elements
            fadeIn(el, duration, index * stagger);
        });

        // Wait for the longest animation to complete
        const maxDelay = (elements.length - 1) * stagger;
        await new Promise(resolve => setTimeout(resolve, duration + maxDelay));
    };

    const updateDrawerLayout = (hasMedia, hasMediaMenu = false) => {
        drawerState = { hasMedia, hasMediaMenu };
        const isExpanded = hasMedia || hasMediaMenu;

        menuDrawer.classList.toggle('has-media', hasMedia);
        menuDrawer.classList.toggle('has-media-menu', hasMediaMenu);
        expandedContainer.classList.toggle('is-expanded', isExpanded);
        mediaDrawer.classList.toggle('is-visible', hasMedia);
        mediaDrawer.classList.toggle('has-media-menu', hasMedia && hasMediaMenu);
    };

    const hideActiveMedia = async () => {
        // Fade out all active media and media menus
        const activeMediaElements = expandedContainer.querySelectorAll('.menu-drawer__media > .is-active');
        const activeMediaMenuElements = expandedContainer.querySelectorAll('.menu-drawer__media-menu.is-active');

        activeMediaElements.forEach((media) => {
            const video = media.querySelector('video');
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        });

        await Promise.all([
            fadeOutAll(activeMediaElements, 150),
            fadeOutAll(activeMediaMenuElements, 150)
        ]);
    };

    const hideActiveMiddleMenu = async () => {
        const activeMiddleMenus = menuDrawer.querySelectorAll('.ms-drawer-middle-menu.is-active');
        await fadeOutAll(activeMiddleMenus, 150);
    };

    const showMedia = async (targetMedia, targetMediaMenu = null) => {
        // Show media menu first (if exists)
        if (targetMediaMenu) {
            targetMediaMenu.classList.add('is-active');
            await fadeIn(targetMediaMenu, 200);
        }

        // Then show media with slight stagger for visual appeal
        if (targetMedia && targetMedia.length > 0) {
            await fadeInAll(targetMedia, 200, 50);
            targetMedia.forEach((media) => {
                const video = media.querySelector('video');
                if (video && media.dataset.autoplay === 'true') {
                    video.play().catch(() => {});
                }
            });
        }
    };

    const handleMenuItemClick = async (menuElement) => {
        const request = ++menuRequest;
        const itemType = menuElement.getAttribute('data-item-type');
        const targetBreadcrumbs = breadcrumbsByType.get(itemType) || [];
        const targetMiddleMenu = middleMenusByType.get(itemType);
        const targetMedia = mediaByType.get(itemType) || [];
        const hasMedia = targetMedia.length > 0;

        // Update layout first (width changes happen instantly)
        updateDrawerLayout(hasMedia);

        // Fade out everything current
        await Promise.all([
            hideActiveMedia(),
            hideActiveMiddleMenu()
        ]);
        if (request !== menuRequest) return;

        // Hide target breadcrumbs (they're being replaced)
        targetBreadcrumbs.forEach((breadcrumb) => {
            breadcrumb.classList.add('is-hidden');
        });

        // Show new middle menu with fade in
        if (targetMiddleMenu) {
            targetMiddleMenu.classList.add('is-active');
            await fadeIn(targetMiddleMenu, 250);
        }

        // Show new media
        if (hasMedia) {
            await showMedia(targetMedia);
        }
    };

    topMenuItems.forEach(item => {
        item.addEventListener('click', function () {
            topMenuItems.forEach(menuItem => {
                menuItem.classList.remove('active');
            });
            item.classList.add('active');
            handleMenuItemClick(item);
        });
    });

    breadcrumbs.forEach(breadcrumb => {
        breadcrumb.addEventListener('click', function (event) {
            event.preventDefault();
            handleMenuItemClick(breadcrumb);
        });
    });

    middleMenuItems.forEach(function (middleMenuItem) {
        middleMenuItem.addEventListener('click', async function (event) {
            event.preventDefault();
            const request = ++menuRequest;
            const itemType = middleMenuItem.getAttribute('data-item-type');
            const targetMediaMenu = mediaMenusByType.get(itemType);
            const targetMedia = mediaByType.get(itemType) || [];
            const hasMediaMenu = !!targetMediaMenu;
            const hasMedia = targetMedia.length > 0;

            // Update layout
            updateDrawerLayout(hasMedia, hasMediaMenu);

            // Fade out current media
            await hideActiveMedia();
            if (request !== menuRequest) return;

            // On mobile, hide middle menu
            if (mobileBreakpoint.matches) {
                await hideActiveMiddleMenu();
            }

            // Show hidden breadcrumbs
            const hiddenBreadcrumbs = navigationContainer.querySelectorAll('.breadcrumb.ms-drawer-middle-primary.is-hidden');
            hiddenBreadcrumbs.forEach(function (breadcrumb) {
                breadcrumb.classList.remove('is-hidden');
            });

            if (mobileBreakpoint.matches) {
                const hiddenExpandedBreadcrumbs = expandedContainer.querySelectorAll('.breadcrumb.ms-drawer-middle-primary.is-hidden');
                hiddenExpandedBreadcrumbs.forEach(function (breadcrumb) {
                    breadcrumb.classList.remove('is-hidden');
                });
            }

            // Show media menu and media with proper sequencing
            await showMedia(targetMedia, targetMediaMenu);
        });
    });

    // 3e niveau (ex. Brands › Goyard › …) : remplace la liste des marques par le sous-menu,
    // dans la même colonne. Les images restent celles de la rubrique, sauf si des blocs
    // "drawer" utilisent le handle du sous-menu (ex. women-brands-goyard).
    let subMenuOwnMedia = false;

    const switchMediaMenu = async (type, isBack) => {
        const targetMenu = mediaMenusByType.get(type);
        if (!targetMenu) return false;
        const request = ++menuRequest;
        const targetMedia = mediaByType.get(type) || [];
        const swapMedia = isBack ? subMenuOwnMedia : targetMedia.length > 0;
        const activeMenus = expandedContainer.querySelectorAll('.menu-drawer__media-menu.is-active');

        if (swapMedia) {
            updateDrawerLayout(targetMedia.length > 0, true);
            await hideActiveMedia();
        } else {
            await fadeOutAll(activeMenus, 150);
        }
        if (request !== menuRequest) return true;

        subMenuOwnMedia = !isBack && targetMedia.length > 0;
        if (swapMedia) {
            await showMedia(targetMedia, targetMenu);
        } else {
            targetMenu.classList.add('is-active');
            await fadeIn(targetMenu, 200);
        }
        return true;
    };

    expandedContainer.querySelectorAll('.ms-drawer-sub-open[data-item-type]').forEach(function (item) {
        item.addEventListener('click', async function (event) {
            if (!mediaMenusByType.get(item.dataset.itemType)) return;
            event.preventDefault();
            await switchMediaMenu(item.dataset.itemType, false);
        });
    });

    expandedContainer.querySelectorAll('.ms-drawer-sub-back[data-target-type]').forEach(function (back) {
        back.addEventListener('click', async function (event) {
            event.preventDefault();
            await switchMediaMenu(back.dataset.targetType, true);
        });
    });

    // Initialize with first menu
    topMenuItems[0].click();

    mobileBreakpoint.addEventListener('change', () => {
        updateDrawerLayout(drawerState.hasMedia, drawerState.hasMediaMenu);
    });

    const handleVideoPlayback = (buttons, action) => {
        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                const video = button.parentElement.querySelector('video');
                const currentButton = button.parentElement.querySelector(`.drawer-video__${action}-button`);
                if (video) {
                    action === 'play' ? video.play() : video.pause();
                    currentButton.style.display = 'none';
                    const otherButton = button.parentElement.querySelector(`.drawer-video__${action === 'play' ? 'pause' : 'play'}-button`);
                    otherButton.style.display = 'flex';
                }
            });
        });
    };

    const playButtons = document.querySelectorAll('.drawer-video__play-button');
    const pauseButtons = document.querySelectorAll('.drawer-video__pause-button');

    handleVideoPlayback(playButtons, 'play');
    handleVideoPlayback(pauseButtons, 'pause');
});